module.exports = __webpack_public_path__ + "media/images/country_flags/as-f6139db9d7109267eaed41a4f964ac57.png";